<template lang="pug">
v-alert.ma-0.ibm.white--text.text-center.text-body-2.font-weight-medium(
  v-model="model"
  color="primary accent-2"
  min-height=48
  tile
  dismissible
  :style="{ position: 'fixed', top: `${$vuetify.application.top}px`, 'z-index': 5 }"
  width="100%"
)
  span(v-html="text")
  template(#close="{ toggle }")
    v-btn(color="white" icon @click="toggle")
      v-icon mdi-close
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  props: [],
  components: {},
  data: () => ({}),
  computed: {
    ...mapFields('page', ['alert.model', 'alert.text'])
  }
}
</script>

<style lang="sass" scoped></style>
